module.exports = __webpack_public_path__ + "static/media/sou_profissional.1ac22611.jpeg";